<template>
  <div class="menu-container">
    <div v-if="firstMenu.length > 0">
      <el-menu
        :default-active="activeIndex"
        :class="screen === 'web' ? 'el-menu-demo' : 'el-menu-demo phone-el-menu-demo'"
        mode="horizontal"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item
          @click="handleSelect(index, item.id)"
          v-for="(item, index) in firstMenu"
          :index="String(index)"
          :key="item.id"
        >{{item.name}}</el-menu-item>
        <!-- <el-menu-item index="3" disabled>消息中心</el-menu-item> -->
        <!-- <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
      </el-menu>
      <div
        class="menu-bg-picture"
        v-if="firstMenu[Number(activeIndex)].imageListFormatter.length > 0"
      >
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item
            v-for="(item, index) in firstMenu[Number(activeIndex)].imageListFormatter"
            :key="item + index"
          >
            <img :src="baseImageUrl + item" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'menu',
  props: {
    activeIndex: String,
    firstMenu: Array,
  },
  data() {
    return {
      router: true,
      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      secondActiveIndex: this.$route.params.secondActiveIndex,
      secondId: this.$route.params.secondId,
      thirdActiveIndex: this.$route.params.thirdActiveIndex,
      thirdId: this.$route.params.thirdId,
    };
  },
  created() {

  },
  computed: {
    ...mapGetters([
      'systemName',
      'baseImageUrl',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
      'screen'
    ]),
  },
  mounted() {
    console.log(this.firstId, this.firstActiveIndex, this.firstMenuMutation, '66666666666666666======');
    if (!this.firstId) {
      if (this.firstMenuMutation.length === 0) {
        this.menuListNoPagination({ level: 1 }).then(res => {
          if (res.success) {
            this.handleSelect(0, res.data[0].id);
          }
        })
      } else {
        this.handleSelect(0, this.firstMenuMutation[0].id);
      }
    }
  },
  methods: {
    ...mapActions(['menuListNoPagination']),
    handleSelect(activeIndexProp, firstClassId) {
      this.activeIndex = activeIndexProp.toString();
      this.$emit('activeIndexBychild', {
        firstActiveIndex: this.activeIndex,
        firstClassId,
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less" scoped>
.menu-container {
  transition: width 0.28s ease-out;
  // background: #409EFF;
  .el-menu-demo {
    padding: 0 7.5%;
    // height: 0.8rem;
  }
  .phone-el-menu-demo {
    padding: 0 0.1rem !important;
  }
  .el-menu {
    // width: 100%;
    border-right: none;
    overflow: auto;
    background-color: #409eff !important;
    // height: 0.8rem !important;
  }
  .el-menu-item {
    background-color: #409eff !important;
    font-size: 0.26rem !important;
    font-weight: bold;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
  }
  .menu-bg-picture {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
